import {
  fourtyFiveDeg,
  ninetyDeg,
  oneEightyDeg,
  oneThirtyFiveDeg,
  pi,
} from '../../store/baseValues'

export function calcRotation(cp: number, angle: number): [number, number] {
  // It must be rotated on the Y axes by MATH.PI if it's on the right, aka going downwards or leftwards
  switch (true) {
    case angle >= pi:
      return [0, oneEightyDeg]
    case angle === 0:
      return [0, 0]
    case angle === ninetyDeg:
      return [0, 0]
    case angle === oneEightyDeg:
      return [0, -oneEightyDeg]
    case angle === -ninetyDeg:
      return [0, oneEightyDeg]
    //0-45
    case angle > 0 && angle <= fourtyFiveDeg:
      return [0, 0]
    //45-90
    case angle > 0 && angle > fourtyFiveDeg && angle <= ninetyDeg:
      return [0, 0]
    //90-135
    case angle > 0 && angle > ninetyDeg && angle <= oneThirtyFiveDeg:
      return [0, 0]
    //135-180
    case angle > 0 && angle > oneThirtyFiveDeg && angle <= oneEightyDeg:
      return [0, 0]

    // -360-<-- -180 --<-- -135 --<-- -90 --<-- -45 --<-- 0
    case angle < 0 && angle >= -fourtyFiveDeg:
      return [0, -pi]
    //0-45
    case angle < 0 && angle < -fourtyFiveDeg && angle >= -ninetyDeg:
      return [0, -pi]
    //45-90
    case angle < 0 && angle < -ninetyDeg && angle >= -oneThirtyFiveDeg:
      return [0, -pi]
    //90-135
    case angle < 0 && angle < -oneThirtyFiveDeg && angle >= oneEightyDeg:
      //Not used?
      return [0, 0]
    // //135-180
    default:
      return [0, 0] //Targets none
  }
}
